import * as React from 'react';
import FormFields, {FormFieldsProps} from '../FormFields';
import {FieldWithName} from '../FormSections/consts';
import {Omit} from 'utility-types';
import fieldsInfoToFormFields from '../utils/fieldsInfoToFormFields';

export interface FormFieldsFromFieldsInfoProps extends Omit<FormFieldsProps, 'fields'> {
  fieldsInfo: FieldWithName[];
}

const FormSectionFields: React.FunctionComponent<FormFieldsFromFieldsInfoProps> = React.memo(
  ({fieldsInfo, ...props}) => {
    return <FormFields {...props} fields={fieldsInfoToFormFields(fieldsInfo)} />;
  }
);

export default FormSectionFields;
